import axios from 'axios';
import CryptoJS from 'crypto-js';
import API from '../../utils/APIUtils.js';

export const getPersonalProfileAPIHelper = async () => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/userprofile/other/personal_profile`, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                // "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const getProfessionalProfileAPIHelper = async () => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/other/professional_profile`, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                // "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};



export const postPersonalProfileApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/userprofile/personal_profile`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        })
        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const postPersonalProfileHobbiesApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/userprofile/hobbies`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const postPersonalProfileLanguagesApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/language`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const getPersonalProfileLanguagesApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/userprofile/language/my_personal_profile`, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                // "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const postPersonalProfileGenerateAboutMeApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/openai/generate-about-me-personal`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

      
        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const postProfessionalProfileGenerateAboutMeApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/openai/generate-about-me`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

       
        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const postPersonalProfileFamilyApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/userprofile/family_info`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

 
        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const getPersonalProfileFamilyApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/family_info`, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                // "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const deletePersonalProfileFamilyApi = async (id) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/userprofile/family_info/member/${id}`, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            },

        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};



export const postPersonalProfileUpdateVisibilityApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/update_profile_visibility`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });


        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const postPersonalProfileHealthApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/health_info`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

     
        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const getPersonalProfileHealthApi = async () => {
    try {
        // const token = localStorage.getItem('objectId');
        // const apiKey = process.env.REACT_APP_API_KEY;
        // setAuthHeader(token);

        const response = await API.get(`userprofile/health_info`, {
            headers: {
                "Content-Type": "application/json"
            }
        });


        return response.data; // Assuming you only need the data part of the response
    } catch (error) {
        console.error('API error:', error);
        if (error?.response) {
            return error.response.data; // Return the error's response data
        } else if (error?.request) {
            return { message: 'No response received from server' };
        } else {
            return { message: error.message };
        }
    }
};


export const getProfileCompletionStatusApi = async () => {
    try {
        // const token = localStorage.getItem('objectId');
        // const apiKey = process.env.REACT_APP_API_KEY;
        // setAuthHeader(token);

        const response = await API.get(`api/v1/userprofile/profile_completion_status`, {
            headers: {
                "Content-Type": "application/json"
            }
        });


        return response.data; // Assuming you only need the data part of the response
    } catch (error) {
        console.error('API error:', error);
        if (error?.response) {
            return error.response.data; // Return the error's response data
        } else if (error?.request) {
            return { message: 'No response received from server' };
        } else {
            return { message: error.message };
        }
    }
};

export const getProfileHealthDocumentsApi = async () => {
    try {
        // const token = localStorage.getItem('objectId');
        // const apiKey = process.env.REACT_APP_API_KEY;
        // setAuthHeader(token);

        const response = await API.get(`userprofile/upload_document/user_health_info`, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response.data; // Assuming you only need the data part of the response
    } catch (error) {
        console.error('API error:', error);
        if (error?.response) {
            return error.response.data; // Return the error's response data
        } else if (error?.request) {
            return { message: 'No response received from server' };
        } else {
            return { message: error.message };
        }
    }
};

export const getPersonalProfileHobbiesApi = async () => {
    try {
        // const token = localStorage.getItem('objectId');
        // const apiKey = process.env.REACT_APP_API_KEY;
        // setAuthHeader(token);

        const response = await API.get(`/userprofile/hobbies`, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        
        return response.data; // Assuming you only need the data part of the response
    } catch (error) {
        console.error('API error:', error);
        if (error?.response) {
            return error.response.data; // Return the error's response data
        } else if (error?.request) {
            return { message: 'No response received from server' };
        } else {
            return { message: error.message };
        }
    }
};

export const getPersonalProfileApi = async () => {
    try {
        // const token = localStorage.getItem('objectId');
        // const apiKey = process.env.REACT_APP_API_KEY;
        // setAuthHeader(token);

        const response = await API.get(`userprofile/personal_profile`, {
            headers: {
                "Content-Type": "application/json",
                // "ngrok-skip-browser-warning": "69420",
            }
        });

        return response.data; // Assuming you only need the data part of the response
    } catch (error) {
        console.error('API error:', error);
        if (error?.response) {
            return error.response.data; // Return the error's response data
        } else if (error?.request) {
            return { message: 'No response received from server' };
        } else {
            return { message: error.message };
        }
    }
};


export const postProfessionalProfileApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_profile`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const getProfessionalInfoApi = async () => {
    try {

        // const token = localStorage.getItem('objectId');
        // const apiKey = process.env.REACT_APP_API_KEY;
        // setAuthHeader(token);
        const response = await API.get(`userprofile/professional_profile`, {
            headers: {
                "content-Type": "appication/json",
                // "ngrok-skip-browser-warning": "69420"
            }
        });

        return response.data;
    }
    catch (error) {
        console.log("API Error", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: 'No response received from server' };
        } else {
            return { message: error.message };
        }
    }
};

export const getVideoResumeApi = async () => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };

        // Log the correct values
   

        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/userprofile/upload_document/video_resume`, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
            }
        });


        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const postResumeApi = async (formData) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/upload_document`, formData, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "multipart/form-data",
                "x-api-key": apiKey
            }
        })
        
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const getResumeApi = async () => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };

      
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/userprofile/upload_document/resume_details`, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json"
            }
        });

 
        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const deleteResumeApi = async (id) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        if (!token) {
            return { message: "Unauthorized: No token provided." };
        }

        if (!apiKey) {
            return { message: "API key is required." };
        }


        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/userprofile/delete_document/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,

                "Content-Type": "application/json",
            },
        });


        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const postPersonalProfilImageApi = async (formData) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        if (!token) {
            return { message: "Unauthorized: No token provided." };
        }

        if (!apiKey) {
            return { message: "API key is required." };
        }


        console.log("Sending Request with Headers:", {
            Authorization: `Bearer ${token}`,
            "x-api-key": apiKey,
        });

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/personal_profile`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                // "x-api-key": apiKey,

                "Content-Type": "multipart/form-data",
            },
        });

  
        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const postPersonalProfilCoverImageApi = async (formData) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/personal_profile`, formData, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "multipart/form-data",
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const postProfessionalProfilImageApi = async (formData) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_profile`, formData, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "multipart/form-data",
            }
        });

     
        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const postProfessionalProfilCoverImageApi = async (formData) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };


        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_profile`, formData, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "multipart/form-data",
            }
        });

   
        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const postEducationBlobApi = async (formData) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v3/userprofile/educational_info`, formData, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "multipart/form-data",
            }
        })
      
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}


export const getEducationApi = async () => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/educational_info`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                // "ngrok-skip-browser-warning": "69420",
            }
        })
    
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const postCertificateBlobApi = async (formData) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_certificate`, formData, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "multipart/form-data",
                // "ngrok-skip-browser-warning": "69420",
            }
        })
     
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const getCertificateApi = async () => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_certificate`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                // "ngrok-skip-browser-warning": "69420",
            }
        })
 
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const postExperienceBlobApi = async (formData) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v3/userprofile/professional_experience`, formData, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "multipart/form-data"
            }
        })
  
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const getExperienceApi = async () => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_experience`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                // "ngrok-skip-browser-warning": "69420"
            }
        })
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const postProjectBlobApi = async (formData) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_project`, formData, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "multipart/form-data"
            }
        })

        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const getProjectApi = async () => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_project`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json"
            }
        })

        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const postServiceBlobApi = async (formData) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_service`, formData, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "multipart/form-data"
            }
        })
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const getServiceApi = async () => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_service`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json"
            }
        })
     
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}


export const postAwardsBlobApi = async (formData) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_award`, formData, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "multipart/form-data",
                "x-key-type": apiKey
            }
        })
   
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const getAwardsApi = async () => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_award`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json"
            }
        })
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const postHealthBlobApi = async (formData) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/upload_document`, formData, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "multipart/form-data",
                "x-api-key": apiKey
            }
        })
   
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const postProfessionalSkillsApi = async (data) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_skils`, data, {
            headers: {
                Authorization: setAuthHeader(token),
                // "x-api-key": apiKey,
                "Content-Type": "application/json"
            }
        })
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}


export const getProfessionalSkillsApi = async () => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_skils`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json"
            }
        })
  
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}


export const postGenerateDescriptionApi = async (prompt) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/openai/generate-description`, prompt, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json"
            }
        })
     
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const deleteEducationApi = async (id) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        if (!token) {
            return { message: "Unauthorized: No token provided." };
        }

        if (!apiKey) {
            return { message: "API key is required." };
        }

        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/educational_info/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const deleteCertificateApi = async (id) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        if (!token) {
            return { message: "Unauthorized: No token provided." };
        }

        if (!apiKey) {
            return { message: "API key is required." };
        }

        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_certificate/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,

                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};
export const deleteExperienceApi = async (id) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        if (!token) {
            return { message: "Unauthorized: No token provided." };
        }

        if (!apiKey) {
            return { message: "API key is required." };
        }

        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_experience/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,

                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const deleteProjectApi = async (id) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        if (!token) {
            return { message: "Unauthorized: No token provided." };
        }

        if (!apiKey) {
            return { message: "API key is required." };
        }


        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_project/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,

                "Content-Type": "application/json",
            },
        });

   
        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const deleteAwardsApi = async (id) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        if (!token) {
            return { message: "Unauthorized: No token provided." };
        }

        if (!apiKey) {
            return { message: "API key is required." };
        }

        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_award/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,

                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};

export const deleteServicesApi = async (id) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        if (!token) {
            return { message: "Unauthorized: No token provided." };
        }

        if (!apiKey) {
            return { message: "API key is required." };
        }


        console.log("Sending Request with Headers:", {
            Authorization: `Bearer ${token}`,
            "x-api-key": apiKey,
        });

        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_service/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": apiKey,

                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("API Error:", error);

        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const postVerifyByAdminApi = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/verify/by-admin`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "multipart/form-data",
            }
        });

        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const UniversityList = async (Data) => {
    try {
        const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/india-universities-list`, Data, {
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });

 
        return response.data;
    } catch (error) {
        console.log("API Error:", error);
        if (error?.response) {
            return error.response.data;
        } else if (error?.request) {
            return { message: "No response received from server" };
        } else {
            return { message: error.message };
        }
    }
};


export const getRecommendation = async () => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/get-recommendations`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
            }
        })
       
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}


export const patchRecommendation = async (id) => {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };

    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/update-recommendation-visibility/${id}`,
            {}, // Empty body if no request payload is needed
            {
                headers: {
                    Authorization: setAuthHeader(token), // Correct placement
                    "Content-Type": "application/json",
                    "x-api-key": apiKey,
                }
            }
        );
     
        return response.data;
    } catch (error) {
        console.error("API ERROR", error);
        if (error.response?.data?.message) {
            return error.response.data.message;
        } else if (error.request) {
            return { message: 'Server not found' };
        } else {
            return { message: error.message };
        }
    }
};


export const deleteRecommendation = async (id) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/delete-recommendation/${id}`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
            }
        })
     
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}


export const getLogoAPI = async (data) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };

    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/companies-master?search=${data}`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        })

    
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const getEducationLogoAPI = async (data) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/companies-master`, {

            params: {
                search: data,
                limit: '',
                type: "education"
            },
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        })
    
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}

export const getExperienceLogoAPI = async (data) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/companies-master`, {

            params: {
                search: data,
                limit: '',
                type: null
            },
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        })
   
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
}


export const deleteProfessionalExperience = async (id) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v2/userprofile/professional_experience/${id}`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
            }
        })
  
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
};


export const deleteProfessionalEducation = async (id) => {

    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v2/userprofile/educational_info/${id}`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
            }
        })
    
        return response.data;

    } catch (error) {
        console.log("API ERROR", error);
        if (error.response.message) {
            return error.response.message;
        } else if (error?.request) {
            return { message: 'Server not found' }
        } else {
            return { message: error.message }
        }
    }
};


export const patchProfessionalEducation = async (id, data) => {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };

    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_BACKEND_URL}/api/v3/userprofile/educational_info/update/${id}`,
            data, // Empty body if no request payload is needed
            {
                headers: {
                    Authorization: setAuthHeader(token), // Correct placement
                    "Content-Type": "multipart/form-data",
                    "x-api-key": apiKey,
                }
            }
        );
    
        return response.data;
    } catch (error) {
        console.error("API ERROR", error);
        if (error.response?.data?.message) {
            return error.response.data.message;
        } else if (error.request) {
            return { message: 'Server not found' };
        } else {
            return { message: error.message };
        }
    }
};


export const patchProfessionalExperience = async (id, data) => {
    const token = localStorage.getItem("objectId");
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };

    try {
        const response = await axios.patch(
            `${process.env.REACT_APP_BACKEND_URL}/api/v3/userprofile/professional_experience/update/${id}`,
            data, // Empty body if no request payload is needed
            {
                headers: {
                    Authorization: setAuthHeader(token), // Correct placement
                    "Content-Type": "multipart/form-data",
                    "x-api-key": apiKey,
                    // "ngrok-skip-browser-warning": "69420",
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("API ERROR", error);
        if (error.response?.data?.message) {
            return error.response.data.message;
        } else if (error.request) {
            return { message: 'Server not found' };
        } else {
            return { message: error.message };
        }
    }
};


export const getOtherProfessionalInfoAPIHelper = async (payload) => {
    try {
        const userId = CryptoJS.AES.encrypt(
                    payload.toString(),
                    'UserDetailsSecretKey',
                ).toString();


        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/other/professional_profile`,
            {
                headers: {
                   'user-key': decodeURIComponent(userId),
                }
            }
        );
     
        return response?.data;
    } catch (error) {
        console.error("API ERROR", error.response?.data || error.message);
    }
};

// export const getOtherProfessionalInfoAPIHelper = async (payload) => {
//     try {
//       const userId = CryptoJS.AES.encrypt(
//         payload?.userId.toString(),
//         'UserDetailsSecretKey',
//       ).toString();
  
//       const response = await APIOTHERS.get(
//         `/api/v1/userprofile/other/professional_profile`,
//         {
//           headers: {
//             'user-key': decodeURIComponent(userId),
//           },
//         },
//       );
//       return response?.data;
//     } catch (error) {
//       return Promise.reject(error.response?.data || error.message);
//     }
//   };